var map = {
	"./Favicon/acmeicon.png": "./src/common/images/Logo/Favicon/acmeicon.png",
	"./Favicon/albertsonsicon.png": "./src/common/images/Logo/Favicon/albertsonsicon.png",
	"./Favicon/amigosicon.png": "./src/common/images/Logo/Favicon/amigosicon.png",
	"./Favicon/haggenicon.png": "./src/common/images/Logo/Favicon/haggenicon.png",
	"./Favicon/jeweloscoicon.png": "./src/common/images/Logo/Favicon/jeweloscoicon.png",
	"./Favicon/luckyicon.png": "./src/common/images/Logo/Favicon/luckyicon.png",
	"./Favicon/marketstreeticon.png": "./src/common/images/Logo/Favicon/marketstreeticon.png",
	"./Favicon/pavilionsicon.png": "./src/common/images/Logo/Favicon/pavilionsicon.png",
	"./Favicon/randallsicon.png": "./src/common/images/Logo/Favicon/randallsicon.png",
	"./Favicon/safewaysicon.png": "./src/common/images/Logo/Favicon/safewaysicon.png",
	"./Favicon/shawsicon.png": "./src/common/images/Logo/Favicon/shawsicon.png",
	"./Favicon/starmarketicon.png": "./src/common/images/Logo/Favicon/starmarketicon.png",
	"./Favicon/tomthumbicon.png": "./src/common/images/Logo/Favicon/tomthumbicon.png",
	"./Favicon/unitedsupermarketsicon.png": "./src/common/images/Logo/Favicon/unitedsupermarketsicon.png",
	"./Favicon/vonsicon.png": "./src/common/images/Logo/Favicon/vonsicon.png",
	"./acme.png": "./src/common/images/Logo/acme.png",
	"./albertsons.png": "./src/common/images/Logo/albertsons.png",
	"./albertsonsmarket.png": "./src/common/images/Logo/albertsonsmarket.png",
	"./amigos.png": "./src/common/images/Logo/amigos.png",
	"./carrs.png": "./src/common/images/Logo/carrs.png",
	"./haggen.png": "./src/common/images/Logo/haggen.png",
	"./jewelosco.png": "./src/common/images/Logo/jewelosco.png",
	"./lucky.png": "./src/common/images/Logo/lucky.png",
	"./marketstreet.png": "./src/common/images/Logo/marketstreet.png",
	"./paknsave.png": "./src/common/images/Logo/paknsave.png",
	"./pavilions.png": "./src/common/images/Logo/pavilions.png",
	"./randalls.png": "./src/common/images/Logo/randalls.png",
	"./safeways.png": "./src/common/images/Logo/safeways.png",
	"./shaws.png": "./src/common/images/Logo/shaws.png",
	"./starmarket.png": "./src/common/images/Logo/starmarket.png",
	"./tomthumb.png": "./src/common/images/Logo/tomthumb.png",
	"./unitedsupermarkets.png": "./src/common/images/Logo/unitedsupermarkets.png",
	"./vons.png": "./src/common/images/Logo/vons.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/common/images/Logo sync recursive ^\\.\\/.*$";